<template>
  <div class="order-item">
    <div class="order-menu" @click.stop>
      <div class="order-menu__trigger" @click="showMenu = !showMenu">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>
      </div>
      <div class="order-menu__dropdown" v-show="showMenu">
        <div class="order-menu__item" @click="onMenuCheck">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          {{$t('orders.buttonOrderInfo')}}
        </div>
        <div class="order-menu__item order-menu__item--danger" @click="onMenuDelete" v-if="!order.paid">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>
          {{$t('button.delete')}}
        </div>
      </div>
    </div>
    <!--封面-->
    <div :class="['order-cover', coverSizeClass]" @click="$emit('check')">
      <cover :book="order.book"></cover>
    </div>
    <!--订单信息-->
    <div class="order-info">
      <span class="order-date">{{$t('orders.labelCreatedAt')}} {{createdAt}}</span>
      <h4 class="order-title text-ellipsis">
        {{order.book.design.title}}
      </h4>
      <div class="order-detail">
        <p>{{$t('orders.labelOrderId')}}: {{order.orderId}}</p>
        <p v-if="order.bookType === 'diarybook'">{{$t('orders.labelBinding')}}: {{$t(binding)}}</p>
        <p v-else>{{$t('orders.labelType')}}: {{order.book.spoiler}}</p>
        <p class="order-spec">
          <span class="spec-tag">{{typeset}}</span>
          <span class="spec-sep">-</span>
          <span class="spec-tag">{{$t('book.pages')}}: {{order.book.totalPage}}</span>
          <span class="spec-sep">-</span>
          <span class="spec-tag">{{$t('orders.labelQuantity')}}: {{order.quantity}}</span>
        </p>
      </div>
      <div class="order-price">
        <template v-if="order.paid">
          <span class="price-paid">{{$t('orders.labelPaid')}} {{getSymbol(order.currency)}}{{order.paidMoney}}</span>
        </template>
        <template v-else>
          <span class="price-pending">
            {{$t('orders.labelPending')}} {{getSymbol(order.currency)}}{{order.paidMoney}}
          </span>
          <router-link v-if="canBuy"
                       :to="{name: 'order-check', query: {bid: order.bid, binding: order.binding, bookType: order.bookType}}">
            <button class="btn-pay-now">{{$t('checkout.buttonPay')}}</button>
          </router-link>
        </template>
      </div>
      <div class="order-btns" v-if="order.paid">
        <router-link :to="{name: 'preview', query: {bid: order.bid, locked: 1}}">
          <button class="btn default">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></svg>
            {{$t('orders.buttonOrderPreview')}}
          </button>
        </router-link>
        <router-link v-if="canBuy"
                     :to="{name: 'order-check', query: {bid: order.bid, binding: order.binding, bookType: order.bookType}}">
          <button class="btn primary">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>
            {{$t('orders.buttonBuy')}}
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../app.config'
import currency from 'src/mixins/currency'
import FBshare from 'src/mixins/FBShare'
import Cover from '../../components/Cover'

export default {
  name: 'order-item',
  components: { Cover },
  mixins: [currency, FBshare],
  props: {
    order: {
      type: Object
    }
  },
  data () {
    return {
      showMenu: false
    }
  },
  computed: {
    canBuy () {
      return ['a5-1', 'a5-2', 'a4-1', 'a4-2'].includes(this.order.printType)
    },
    coverSizeClass () {
      const { bookType, printType } = this.order
      if (bookType === 'photobook' || bookType === 'calendar') {
        return 'order-cover--wide'
      }
      if (printType && /^a4/i.test(printType)) {
        return 'order-cover--a4'
      }
      return 'order-cover--a5'
    },
    typeset () {
      let typeset = ''
      config.templates.map(item => {
        if (item.name === this.order.printType) {
          typeset = item.desc
        }
      })
      typeset = typeset || 'common.text.a5Waterfall'
      return this.$t(typeset)
    },
    binding () {
      let binding = ''
      config.bindings.map(item => {
        if (item.name === this.order.binding) {
          binding = item.desc
        }
      })
      binding = binding || 'common.text.paperback'
      return binding
    },
    createdAt () {
      return this.$moment(this.order.createdAt).format('YYYY-MM-DD HH:mm')
    }
  },
  mounted () {
    document.addEventListener('click', this.closeMenu)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeMenu)
  },
  methods: {
    closeMenu () {
      this.showMenu = false
    },
    onMenuCheck () {
      this.showMenu = false
      this.$emit('check')
    },
    onMenuDelete () {
      this.showMenu = false
      this.$emit('delete')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';

.order-item {
  width: 100%;
  position: relative;
  overflow: visible;
  border-radius: 12px;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  font-size: 16px;
  border: 1px solid transparent;
  transition: all 0.25s;

  &:hover {
    background-color: white;
    border-color: #e5e7eb;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);

    .order-menu {
      opacity: 1;
    }
  }

  .order-menu {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 5;
    opacity: 0;
    transition: opacity 0.2s;

    &__trigger {
      cursor: pointer;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.9);
      color: #6b7280;
      font-size: 14px;

      &:hover {
        background: #fff;
        color: $el-color-primary;
      }
    }

    &__dropdown {
      position: absolute;
      top: 100%;
      right: 0;
      margin-top: 4px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
      min-width: 140px;
      overflow: hidden;
      z-index: 10;
    }

    &__item {
      padding: 10px 16px;
      font-size: 13px;
      color: #374151;
      display: flex;
      align-items: center;
      gap: 8px;
      white-space: nowrap;
      cursor: pointer;
      transition: background 0.15s;

      &:hover {
        background: #f3f4f6;
      }

      &--danger {
        color: #ef4444;
        &:hover {
          background: #fef2f2;
        }
      }
    }
  }

  .order-cover {
    flex: 0 0 auto;
    cursor: pointer;
    padding: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;

    // A5 日记书 — 窄封面
    &--a5 {
      width: 170px;
    }

    // A4 日记书 — 稍宽
    &--a4 {
      width: 200px;
    }

    // 相片书/月历 — 宽封面
    &--wide {
      width: 230px;
    }

    ::v-deep .cover {
      width: 100%;
    }

    ::v-deep .cover-holder {
      width: 100%;
      border-radius: 2px 4px 4px 2px;
      border-left: 4px solid #ddd9d4;
      box-shadow:
        3px 3px 6px rgba(0, 0, 0, 0.15),
        6px 6px 12px rgba(0, 0, 0, 0.08);
    }

    @media (max-width: 767px) {
      padding: 0.75rem;

      &--a5 {
        width: 120px;
      }

      &--a4 {
        width: 140px;
      }

      &--wide {
        width: 160px;
      }
    }
  }

  .order-info {
    flex: 1;
    min-width: 0;
    padding: 1.25rem 1.5rem 1.5rem 0;
    text-align: left;
    display: flex;
    flex-direction: column;
  }

  .order-date {
    font-size: 12px;
    color: #9ca3af;
    white-space: nowrap;
    margin-bottom: 2px;
  }

  .order-title {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 4px;
  }

  .order-detail {
    font-size: 13px;
    color: #9ca3af;
    padding-left: 0;

    p {
      margin: 0;
      line-height: 1.5;
    }
  }

  .order-spec {
    display: inline-flex;
    align-items: center;
    background: #f3f4f6;
    border-radius: 4px;
    padding: 4px 10px;
    margin: 10px 0 0 !important;
    font-size: 12px;
    color: #6b7280;
    font-weight: 500;

    .spec-sep {
      margin: 0 6px;
      color: #d1d5db;
    }

    .spec-tag {
      white-space: nowrap;
    }
  }

  .order-price {
    margin: 4px 0;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 10px;

    .price-paid {
      color: $el-color-done;
    }

    .price-pending {
      color: #f59e0b;
    }

    .btn-pay-now {
      font-size: 12px;
      padding: 2px 12px;
      border-radius: 100px;
      border: 1px solid $el-color-primary;
      color: $el-color-primary;
      background: transparent;
      cursor: pointer;
      transition: all 0.2s;
      white-space: nowrap;

      &:hover {
        background: $el-color-primary;
        color: #fff;
      }
    }
  }

  .order-btns {
    margin-top: 12px;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;

    button {
      min-width: 100px;
      font-weight: 500;
      font-size: 13px;
      padding: 6px 22px;
    }

    @media (max-width: 767px) {
      button {
        min-width: 70px;
        padding: 6px 14px;
        font-size: 12px;
      }
    }
  }
}
</style>
